import React from "react"

import Alert from "react-bootstrap/Alert"
import { FormattedMessage } from "react-intl"
import _ from "lodash"
export const FormattedSuccess = ({ msg, onClose=f=>f }) => {

  return (
    <Alert variant="darkBlue" onClose={onClose} dismissible={_.isFunction(onClose) ? true : false}>
      <div className="alert-text font-weight-bold">
        <i className="fa fa-check text-white" /> { " " }
        <FormattedMessage id={ msg || "GENERAL.SUCCESS" } />
      </div>
    </Alert>
  )
}
